exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js??ref--7-1!../../styles/colors.css"), "");

// Module
exports.push([module.id, ".src-components-CameraNotAccessibleModal-___styles__body___1Zc3- {\n  text-align: center;\n}\n\na {\n  margin-top: 5px;\n}", ""]);

// Exports
exports.locals = {
	"colors": "\"../../styles/colors.css\"",
	"shade6": "" + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--7-1!../../styles/colors.css").locals["shade6"] + "",
	"body": "src-components-CameraNotAccessibleModal-___styles__body___1Zc3-"
};